import { render } from "./Dashboard.vue?vue&type=template&id=af38c5ea"
const script = {}

import "./Dashboard.vue?vue&type=style&index=0&id=af38c5ea&lang=css"

import exportComponent from "/home/tchery/dev/assiette-parfaite/frontend-gesit/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__